/**
 * Russian strings of the 09 inbox (see `uz-09-inbox.ts`). Spread into `ru`; a key missing here
 * falls back to Uzbek like every other.
 */
import type { TranslationKey } from "./uz";

export const ruInbox09: Partial<Record<TranslationKey, string>> = {
  "inbox09.channel.label": "Канал",
  "inbox09.liveRetrying": "Переподключение",
  "inbox09.search.label": "Поиск по диалогам",
  "inbox09.section.inbox": "Диалоги",
  "inbox09.section.comments": "Комментарии Instagram",
  "inbox09.section.nav": "Диалоги и комментарии",

  "inbox09.list.label": "Список диалогов",
  "inbox09.list.error": "Не удалось загрузить диалоги.",
  "inbox09.list.unknownClient": "Неизвестный клиент",
  "inbox09.list.unread": "Непрочитанных: {count}",
  "inbox09.list.pick": "Выбрать {name}",
  "inbox09.retry": "Повторить",
  "inbox09.time.now": "сейчас",
  "inbox09.time.minutes": "{count} мин",
  "inbox09.time.yesterday": "вчера",
  "inbox09.claim.done": "Диалог закреплён за вами.",
  "inbox09.claim.taken": "Этот диалог уже взял(а) {name}.",
  "inbox09.claim.failed": "Не удалось взять диалог.",
  "inbox09.comment.kind": "Комментарий Instagram",
  "inbox09.comment.status": "Ждёт ответа",
  "inbox09.need.adults": "Взрослых: {count}",
  "inbox09.need.children": "Детей: {count}",
  "inbox09.header.dealCreated": "Сделка создана.",
  "inbox09.header.dealExists": "У клиента есть открытая сделка, диалог привязан к ней.",
  "inbox09.header.dealFailed": "Не удалось создать сделку.",
  "inbox09.header.cancel": "Отмена",

  "inbox09.draft.label": "Ответ AI на проверке",
  "inbox09.draft.source": "Источник: {sources}",
  "inbox09.draft.noSource": "Источник: цитат из базы знаний нет",
  "inbox09.draft.send": "Отправить",
  "inbox09.draft.edit": "Изменить",
  "inbox09.draft.reject": "Отклонить",
  "inbox09.draft.rejectReason": "Причина отклонения",
  "inbox09.draft.rejectPlaceholder": "Что не так?",
  "inbox09.draft.sendFailed": "Не удалось отправить черновик.",
  "inbox09.draft.rejectFailed": "Не удалось отклонить черновик.",
  "inbox09.draft.notYours": "Ответ подтверждает сотрудник, взявший диалог.",
  "inbox09.bubble.aiSent": "Отправил AI · {time}",
  "inbox09.bubble.approvedBy": "Подтвердил(а) {name}",
  "inbox09.bubble.client": "Сообщение клиента",
  "inbox09.attachment.open": "Открыть: {kind}",
  "inbox09.attachment.pending": "Файл загружается из Telegram",
  "inbox09.attachment.failed": "Файл получить не удалось",
  "inbox09.attachment.tooLarge": "Файл слишком большой, откройте его в Telegram",
  "inbox09.attachment.removed": "Файл удалён: срок хранения истёк",
  "inbox09.attachment.retry": "Повторить",
  "inbox09.attachment.retryFailed": "Не удалось запросить файл повторно.",

  "inbox09.composer.template": "Шаблон",
  "inbox09.composer.tour": "Прикрепить тур",
  "inbox09.composer.checklist": "Список документов",
  "inbox09.composer.note": "Внутренняя заметка",
  "inbox09.composer.file": "Файл",
  "inbox09.composer.noteFailed": "Не удалось сохранить заметку.",
  "inbox09.composer.checklistFailed": "Не удалось получить список документов.",

  "inbox09.panel.label": "Данные клиента",
  "inbox09.panel.error": "Не удалось загрузить данные.",
  "inbox09.panel.noClient": "Клиент не определён",
  "inbox09.panel.source": "Источник",
  "inbox09.panel.returning": "Повторный клиент",
  "inbox09.panel.need": "Потребность по данным AI",
  "inbox09.panel.needEmpty": "Ещё не определена",
  "inbox09.panel.createDealWithNeed": "Создать сделку с этими данными",
  "inbox09.panel.visa": "Документы",
  "inbox09.panel.sendChecklist": "Отправить список документов",
  "inbox09.panel.trips": "Прошлые поездки",
  "inbox09.panel.tripsEmpty": "Раньше не путешествовал(а)",
  "inbox09.panel.tasks": "Задачи",
  "inbox09.panel.call": "Звонок",
  "inbox09.panel.card": "Карточка клиента",

  "inbox09.commentView.label": "Комментарий Instagram",
  "inbox09.commentView.post": "Открыть пост",
  "inbox09.commentView.public": "Публичный ответ",
  "inbox09.commentView.direct": "Перевести в Direct",
  "inbox09.commentView.text": "Текст ответа",
  "inbox09.commentView.publicSent": "Публичный ответ отправлен.",
  "inbox09.commentView.directSent": "Сообщение в Direct отправлено.",
  "inbox09.commentView.failed": "Не удалось отправить ответ.",
};
